import PropTypes from 'prop-types';
import React, { Component } from 'react';
import _ from 'lodash';
import TextField from 'material-ui/TextField';
import { List, ListItem, makeSelectable } from 'material-ui/List';
import Toggle from 'material-ui/Toggle';
import { localize } from '../i18n';

const SelectableList = makeSelectable(List);

class SelectLocations extends Component {
  constructor(props) {
    super(props);
    this.state = {
      changedLocations: this.props.selectedLocations,
      revertLocations: this.props.selectedLocations,
      filteredLocations: [],
      locationFilter: '',
    };
  }

  componentWillMount() {
    if (this.props.locations.length > 0) {
      this.setState(Object.assign({}, this.state, {
        filteredLocations: this.props.locations,
      }));
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.locations.length > 0 && nextProps.locations.length > this.props.locations.length) {
      this.setState(Object.assign({}, this.state, {
        filteredLocations: nextProps.locations,
      }));
    }
  }

  filterLocations(evt, type, value) {
    let selectedFilter = this.state.selectedFilter;
    let filteredLocations = this.props.locations;
    if (type === 'search' && value.length > 0) {
      filteredLocations = _.filter(this.props.locations, loc => loc.location_name.indexOf(value) !== -1);
    } else if (type === 'selected' && value === true && this.state.changedLocations.length > 0) {
      filteredLocations = _.filter(this.props.locations, loc => this.state.changedLocations.indexOf(loc.id) !== -1);
      selectedFilter = value;
    }
    this.setState(Object.assign({}, this.state, {
      filteredLocations,
      locationFilter: value,
      selectedFilter,
    }));
  }

  handleItemSelect(evt, locationId) {
    let currentSelectedLocations = this.state.changedLocations;
    const currentSelectedIdx = currentSelectedLocations.indexOf(locationId);
    if (currentSelectedIdx !== -1) {
      currentSelectedLocations = this.state.changedLocations.slice(0, currentSelectedIdx);
      currentSelectedLocations = currentSelectedLocations.concat(this.state.changedLocations.slice(currentSelectedIdx + 1));
    } else {
      currentSelectedLocations.push(locationId);
    }
    this.setState(Object.assign({}, this.state, {
      changedLocations: currentSelectedLocations,
    }));
  }

  handleClearLocations() {
    this.setState(Object.assign({}, this.state, {
      changedLocations: [],
      revertLocations: [],
    }), () => {
      this.props.onSelectLocations(this.state.changedLocations);
    });
  }

  handleCancelLocations() {
    this.setState(Object.assign({}, this.state, {
      changedLocations: Object.assign([], this.state.revertLocations),
    }), () => {
      this.props.onSelectLocations(this.state.changedLocations);
    });
  }

  handleSelectLocations() {
    this.props.onSelectLocations(this.state.changedLocations);
  }

  render() {
    const {
      filteredLocations,
      changedLocations,
    } = this.state;
    const {
      locations,
    } = this.props;
    let locationList = null;

    if (filteredLocations.length > 0) {
      locationList = filteredLocations.map((loc) => {
        const innerDivStyle = {
          padding: 15,
        };
        if (changedLocations.indexOf(loc.id) !== -1) {
          innerDivStyle.backgroundColor = '#156f9d';
          innerDivStyle.color = '#fff';
        }
        return (
          <ListItem
            key={loc.id}
            primaryText={(loc.location_type === 'guest_room') ? this.props.t('Room {locationName}', { locationName: loc.location_name }) : loc.location_name.toUpperCase()}
            value={loc.id}
            innerDivStyle={innerDivStyle}
          />
        );
      });
    }

    return (
      <div className="md-card">
        <div className="md-card-toolbar">
          <TextField
            className="SearchLocation"
            hintStyle={{ fontSize: 14 }}
            fullWidth
            hintText={this.props.t('Select below or search for location(s)')}
            onChange={evt => this.filterLocations(evt, 'search', evt.target.value)}
          />
        </div>
        <div className="md-card-content md-card-mobile-height-viewport">
          <div className="uk-text-right uk-text-small">
            <Toggle
              defaultToggled={false}
              disabled={(changedLocations.length === 0)}
              label={this.props.t('Show only selected')}
              onToggle={(evt, isInputChecked) => this.filterLocations(evt, 'selected', isInputChecked)}
            />
            <span>{this.props.t('Displaying {filteredLocationsLength} of {locationsLength}', { filteredLocationsLength: filteredLocations.length, locationsLength: locations.length })}</span>
          </div>
          <div className="md-card-selectable-list">
            <SelectableList
              onChange={(evt, locationId) => {
                this.handleItemSelect(evt, locationId);
              }}
            >
              {locationList}
            </SelectableList>
          </div>
        </div>
        <div className="md-card-footer uk-text-right">
          <button type="button" className="md-btn md-btn-wave-light waves-effect waves-button waves-light" onClick={() => this.handleCancelLocations()}>Cancel</button>
          <button
            type="button"
            className={`md-btn md-btn-wave-light waves-effect waves-button waves-light ${(changedLocations.length > 0) ? 'md-btn-primary' : 'disabled'}`}
            disabled={(changedLocations.length === 0)}
            onClick={() => this.handleSelectLocations()}
          >
            {this.props.t('Select')}
          </button>
          <div className="md-card-footer-float-left">
            <button type="button" className="md-btn md-btn-flat md-btn-wave-light waves-effect waves-button waves-light md-btn-flat-danger" onClick={() => this.handleClearLocations()}>{this.props.t('Clear')}</button>
          </div>
        </div>
      </div>
    );
  }
}

SelectLocations.propTypes = {
  locations: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    location_type: PropTypes.string,
    location_name: PropTypes.string,
    location_sort: PropTypes.number,
  })),
  selectedLocations: PropTypes.arrayOf(PropTypes.string),
  onSelectLocations: PropTypes.func,
  t: PropTypes.func.isRequired,
};

SelectLocations.defaultProps = {
  onSelectLocations: () => {},
};

export default localize(SelectLocations);



// WEBPACK FOOTER //
// ./src/components/SelectLocations.js